import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { translate } from 'i18n';

const WHATSAPP_NUMBER = '33612345678'; // TODO: replace with real number

export default function WhatsAppCta(props: ButtonProps) {
  const message = encodeURIComponent(
    "Bonjour, je suis int\u00e9ress\u00e9(e) par MySportSet pour mon club."
  );

  return (
    <Button
      as="a"
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      bg="#25D366"
      color="white"
      _hover={{ bg: '#1fb855' }}
      leftIcon={<Icon as={FaWhatsapp} boxSize={5} />}
      size="lg"
      borderRadius="full"
      fontWeight="600"
      {...props}
    >
      {translate('marketing.whatsapp_cta')}
    </Button>
  );
}
